export enum ECommentsActions {
  SET_MAIN_COMMENT = 'comments/setMainComment',
}
